module.exports = __webpack_public_path__ + "static/media/logo-recruit-sp.100985b4.svg";